(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const editorMotionNode = document.getElementById('EaEditorMotion');
  const editorMotion = editorMotionNode ? JSON.parse(editorMotionNode.textContent) : null;
  if (editorMotion?.mode === 'off') return;
  const customMotion = editorMotion?.mode === 'custom';
  if (reduced.matches || !('IntersectionObserver' in window)) return;

  // Texte und Karten steigen auf, Bildflächen werden aufgedeckt. Kaufbereich, Formulare und Preise bleiben ruhig.
  const groups = [
    ['ea-reveal', '.h-head,.h-facts li,.h-step,.h-mode,.ea-package,.h-kit__list li,.ea-faq details,.ea-moments__copy,.h-final__card,.ea-page-offer__card,.ea-news,.origin-page__band,.origin-page__columns>div,.origin-tools-list a'],
    ['ea-reveal-media', '.h-occ__tile,.h-kit__img,.h-workshop__photo,.ea-moments__main,.origin-occasion__image,.h-final__panel,.ea-page-offer__panel']
  ];
  const parallaxSelector = '.h-bento__a,.ea-moments__main,.h-final__panel,.ea-page-offer__panel';
  const prepared = new WeakSet();
  const pending = new Set();
  const parallaxItems = [];
  let scrollFrame = 0;

  const clear = (element) => {
    element.classList.remove('ea-reveal', 'ea-reveal-media', 'is-in');
    element.style.removeProperty('--ea-delay');
  };
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const element = entry.target;
      revealObserver.unobserve(element);
      pending.delete(element);
      element.classList.add('is-in');
      // Nach dem Auftritt alle Hilfsklassen entfernen, damit Hover und spätere Zustände unberührt bleiben.
      const finish = (event) => {
        if (event.target !== element || !(customMotion ? ['transform', 'opacity'] : ['transform', 'clip-path']).includes(event.propertyName)) return;
        element.removeEventListener('transitionend', finish);
        clear(element);
      };
      element.addEventListener('transitionend', finish);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  function prepare(scope) {
    groups.forEach(([className, selector]) => {
      scope.querySelectorAll(selector).forEach((element) => {
        if (prepared.has(element)) return;
        prepared.add(element);
        if (element.getBoundingClientRect().top < innerHeight * 0.92) return;
        const siblings = [...element.parentElement.children].filter((child) => child.matches(selector));
        element.style.setProperty('--ea-delay', `${Math.min(siblings.indexOf(element), 4) * (customMotion ? editorMotion.stagger : 50)}ms`);
        element.classList.add(className);
        pending.add(element);
        revealObserver.observe(element);
      });
    });
    if (editorMotion?.parallax === 'off') return;
    scope.querySelectorAll(parallaxSelector).forEach((element) => {
      if (parallaxItems.includes(element)) return;
      element.dataset.eaPx = '';
      parallaxItems.push(element);
    });
  }

  function updateScroll() {
    scrollFrame = 0;
    const height = innerHeight;
    parallaxItems.forEach((element) => {
      const rect = element.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > height) return;
      const progress = (rect.top + rect.height / 2 - height / 2) / (height / 2 + rect.height / 2);
      element.style.setProperty('--ea-py', `${(progress * -(customMotion ? editorMotion.parallaxStrength : 4)).toFixed(2)}%`);
    });
    // Beim schnellen Springen übersprungene Elemente sofort zeigen, damit oberhalb nichts unsichtbar bleibt.
    pending.forEach((element) => {
      if (element.getBoundingClientRect().bottom > 0) return;
      revealObserver.unobserve(element);
      pending.delete(element);
      clear(element);
    });
  }
  const requestUpdate = () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(updateScroll); };

  prepare(document);
  updateScroll();
  addEventListener('scroll', requestUpdate, { passive: true });
  addEventListener('resize', requestUpdate, { passive: true });
  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
})();
